import { Link } from 'react-router-dom';
import { Pill } from '../../components/ui/index.jsx';

export function OutboxStatus({ status, reason }) {
  if (status === 'recorded') return <Pill tone="good">On record as yours</Pill>;
  if (status === 'not_recorded') return <><Pill tone="warn">Couldn’t be proven</Pill>{reason && <div className="muted small">{reason}</div>}</>;
  if (status === 'learned') return <Pill tone="info">Service learned</Pill>;
  return <Pill>Checking…</Pill>;
}

export function ViaText({ via }) {
  if (via.type === 'learn') return <span>Cc’d to learn@</span>;
  return (
    <span>
      Your own list{via.list ? <>: {via.planting_id && via.event_id ? <Link to={`/events/${via.event_id}/plantings/${via.planting_id}`}>{via.list}</Link> : via.list}</> : ''}
      {via.event_name && <div className="muted small">{via.event_name}</div>}
    </span>
  );
}
